// Récupérer les variables d'environnement de manière sécurisée
const getEnvVar = (key, defaultValue) => {
  // Utiliser window.getEnv si disponible (défini dans env-fix.js)
  if (typeof window !== 'undefined' && window.getEnv) {
    return window.getEnv(key, defaultValue);
  }
  
  // Fallback sécurisé
  try {
    if (import.meta && import.meta.env && import.meta.env[key] !== undefined) {
      return import.meta.env[key];
    }
  } catch (error) {
    console.warn(`Erreur lors de l'accès à la variable d'environnement ${key}:`, error);
  }
  
  // Valeur par défaut
  return defaultValue;
};

export const APP_CONFIG = {
  API: {
    TIMEOUT: 30000,
    BASE_URL: getEnvVar('VITE_API_URL', 'https://baobab-exchange-backend.onrender.com/api'),
    WITH_CREDENTIALS: true,
  },
  WEB3: {
    PROVIDER_URL: getEnvVar('VITE_WEB3_PROVIDER', 'https://api.baobab.klaytn.net:8651'),
    CHAIN_ID: getEnvVar('VITE_CHAIN_ID', '1001'),
    NETWORK_NAME: "Baobab Testnet",
  },
  CRYPTOCOMPARE: {
    API_KEY: getEnvVar('VITE_CRYPTOCOMPARE_API_KEY', 'a06d7fef4a55673a949c21bfde92e19977473e1fdb7444dc8f408fcd0d7a6e1a'),
    BASE_URL: 'https://min-api.cryptocompare.com/data',
  },
  TOAST: {
    POSITION: "top-right",
    AUTO_CLOSE: 3000,
    HIDE_PROGRESS_BAR: false,
    NEWEST_ON_TOP: true,
    CLOSE_ON_CLICK: true,
    RTL: false,
    PAUSE_ON_FOCUS_LOSS: true,
    DRAGGABLE: true,
    PAUSE_ON_HOVER: true,
    THEME: "colored",
    LIMIT: 3,
  },
  SERVICE_WORKER: {
    PATH: "/serviceWorker.js",
  },
};
